import UgcWidget from 'components/Content/UgcWidget/UgcWidget';
import { withUGCWidgetProps } from 'viewModel/content/ugcWidget/withUGCWidgetProps';

export default withUGCWidgetProps(UgcWidget);
